import { Link } from "react-router-dom";

export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20and%20amber%20gradients%20on%20dark%20charcoal%20background%2C%20soft%20diffused%20light%20beams%2C%20modern%20minimalist%20editorial%20style%2C%20elegant%20texture%20layers%20with%20subtle%20geometric%20patterns%2C%20no%20text%2C%20clean%20and%20sophisticated%20atmosphere%2C%20high-end%20magazine%20cover%20quality&width=1600&height=900&seq=about-hero-bg-2026&orientation=landscape"
        alt="关于黑料网"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-[900px] mx-auto px-6 md:px-10 text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-medium mb-5">
            <i className="ri-building-line"></i>
            关于我们
          </span>
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-5 leading-tight">
            华语娱乐圈最
            <span className="text-primary-400">真实</span>
            的八卦平台
          </h1>
          <p className="text-sm md:text-base text-white/70 max-w-[620px] mx-auto leading-relaxed">
            诞生于2018年，从三个娱记的梦想出发，如今已成为580万用户信赖的娱乐资讯伙伴。
            我们坚持「真实、快速、有料」，让每一个瓜都值得吃。
          </p>
          <div className="flex items-center justify-center gap-3 mt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-lg font-medium text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line"></i>
              开始吃瓜
            </Link>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/25 text-white rounded-lg font-medium text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i>
              联系我们
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}